import { Col, Drawer, Row, Tabs } from 'antd';
import DataCard from 'components/DataCard';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const AddSignatoryContainerStyled = styled(Row)`
  margin: 0;
  padding: 0;
  height: 100%;
  min-width: 140px;
`;

export const DataCardStyled = styled(DataCard)<{ $isMobileView?: boolean }>`
  & .custom-card-body-content {
    min-width: 290px;
  }
  & .custom-card-avatar-container {
    ${({ $isMobileView }) => ($isMobileView ? 'width: 100%' : '')};
  }
  & .data-card-right-content-container {
    margin-right: 40px !important;
  }
`;

export const NotaryNameStyled = styled.h2<{ $color?: string }>`
  border: none;
  display: inline-block;
  background: transparent;
  color: ${({ $color }) => $color || '#038fde'};
  font-size: 14px;
  padding: 0;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChangeNotaryButtonContainerStyled = styled(Col)`
  @media screen and (max-width: ${breakpoints.sm}) {
    width: 100%;
  }
`;

export const DrawerStyled = styled(Drawer)`
  .ant-drawer-content-wrapper {
    min-width: 450px !important;
    max-width: 500px !important;
    width: 50% !important;
    padding: 0;
    @media (max-width: ${breakpoints.md}) {
      width: 100% !important;
      min-width: 0 !important;
    }
  }
`;

export const EmptyDataContainerStyled = styled.div`
  background: white;
  padding: 30px;
`;

export const AppointmentsTabContainerStyled = styled.div`
  width: 100%;
  height: 100%;
  .ant-tabs-nav-wrap {
    margin-left: 15px;
  }
  .ant-tabs-content-holder {
    padding: 0;
    height: 100%;
  }
`;

export const TabsStyled = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 0;
  }
  height: 100%;
  .ant-tabs-content {
    height: 100%;
  }
`;

export const AvatarContainerStyled = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;
